"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldActionButton = exports.CSS = void 0;
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var icon_1 = require("../icon");
var icons_1 = require("../icon/icons");
var theme_1 = require("../theme");
var photomeasure_svg_1 = require("./photomeasure.svg");
exports.CSS = {
    container: 'c-FieldActionBtn',
    isLinkable: 'c-FieldActionBtn--linkable',
    isLinking: 'c-FieldActionBtn--linking',
    joinable: 'c-FieldActionBtn--joinable',
    linkContainer: 'c-FieldActionBtn__Link',
    photoMeasureIcon: 'c-FieldActionBtn__PhotoMeasure',
    errorIcon: 'c-FieldActionBtn__error'
};
var Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'justify-content': 'flex-end',
        width: '100%'
    },
    _a[exports.CSS.isLinkable + ' button'] = {
        color: theme_1.DefaultTheme.font.color.white,
        'background-color': theme_1.DefaultTheme.color.accent
    },
    _a[exports.CSS.joinable] = {
        'background-image': photomeasure_svg_1.PHOTO_MEASURE_SVG_URL,
        'background-repeat': 'no-repeat',
        'background-size': '18px',
        width: '20px',
        height: '20px',
        'background-position': 'center',
        '&[disabled]': {
            'background-image': photomeasure_svg_1.PHOTO_MEASURE_SVG_URL_DISABLED
        }
    },
    _a[exports.CSS.linkContainer] = {
        'font-size': '12px',
        'background-color': theme_1.DefaultTheme.font.color.supporting,
        border: 'none',
        outline: 'none',
        color: theme_1.DefaultTheme.font.color.white,
        padding: '0 ' + theme_1.DefaultTheme.space(2),
        'align-items': 'center',
        'border-radius': theme_1.DefaultTheme.space(4),
        'font-weight': 'bold',
        display: 'flex',
        cursor: 'pointer',
        '& i': {
            'font-size': '20px',
            'margin-left': theme_1.DefaultTheme.space(1)
        },
        width: '100%',
        'justify-content': 'center'
    },
    _a[exports.CSS.photoMeasureIcon] = {
        transform: ' rotate(-90deg) !important'
    },
    _a[exports.CSS.errorIcon] = {
        color: theme_1.DefaultTheme.font.color.error,
        cursor: 'default'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.FieldActionButton = {
    view: function (cfg) {
        var icon = cfg.linking ? icons_1.MaterialIcon.CLOSE : cfg.icon;
        var text = cfg.linking ? cfg.linkingText : cfg.text;
        var title = cfg.title;
        return (0, mithril_1.m)('div', { className: "".concat(exports.CSS.container, " ").concat(cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable) }, [
            (0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick, title: (0, index_1.Translate)(title) }, [
                (0, index_1.Translate)(text),
                icon_1.Icon.view(icon, { type: 'button' })
            ])
        ]);
    },
    viewLinkHeight: function (cfg) {
        var icon;
        if (cfg.joinable) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.NONE, { type: 'button', className: "".concat(exports.CSS.photoMeasureIcon, " ").concat(exports.CSS.joinable) });
        }
        else if (cfg.linking) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, { type: 'button' });
        }
        else {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.PHOTO_MEASURE, { type: 'button', className: exports.CSS.photoMeasureIcon });
        }
        var text = cfg.linking ? index_1.T.PHOTOMEASURE_LINK : index_1.T.PHOTOMEASURE_LINK_START;
        var title = cfg.joinable ? index_1.T.PHOTOMEASURE_JOIN : index_1.T.PHOTOMEASURE_LINK_START;
        return (0, mithril_1.m)('div', { className: "".concat(exports.CSS.container, " ").concat(cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable) }, [
            (0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick, title: (0, index_1.Translate)(title) }, [
                (0, index_1.Translate)(text),
                icon
            ])
        ]);
    },
    viewLinkVerticalSeparation: function (cfg) {
        var icon;
        var text;
        var className = "".concat(exports.CSS.container, " ").concat(cfg.linking ? exports.CSS.isLinking : exports.CSS.isLinkable);
        var title;
        var errorIcon = icon_1.Icon.view(icons_1.MaterialIcon.WARNING, { type: 'button', className: "".concat(exports.CSS.errorIcon) });
        if (cfg.joinable) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.NONE, { type: 'button', className: "".concat(exports.CSS.photoMeasureIcon, " ").concat(exports.CSS.joinable) });
            text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_TOP);
        }
        else if (cfg.linking) {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, { type: 'button' });
            text = title = (0, index_1.Translate)(index_1.T.PHOTOMEASURE_LINK);
        }
        else {
            icon = icon_1.Icon.view(icons_1.MaterialIcon.PHOTO_MEASURE, { type: 'button', className: exports.CSS.photoMeasureIcon });
            text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_TOP);
            if (cfg.hasTop && !cfg.hasBottom) {
                text = title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_BOTTOM);
            }
        }
        var resultDiv = [];
        if (cfg.hasError) {
            resultDiv.push(errorIcon);
            title = (0, index_1.Translate)(index_1.T.VERTICAL_SEPARATION_INVALID);
        }
        resultDiv.push((0, mithril_1.m)('button', { className: exports.CSS.linkContainer, onclick: cfg.onclick }, [
            text,
            icon
        ]));
        return (0, mithril_1.m)('div', { className: className, title: title }, resultDiv);
    }
};
//# sourceMappingURL=field.action.button.js.map